export default {
  VERTICAL: 'orientation-vertical',
  HORIZONTAL: 'orientation-horizontal'
};